import { ReactNode } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

interface Props {
    open?: boolean;
    children?: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    className?: string;
    contentClassName?: string;
}

export function SideSheet({ open = true, children, className, header, footer, contentClassName }: Props) {
    if (!open) {
        return null;
    }

    return (
        <>
            <div className="fixed inset-0 z-40 bg-black opacity-45 md:block" />

            <div
                className={twJoin(
                    'fixed right-0 top-0 z-50 flex h-full w-full flex-col bg-white shadow-xl transition-transform duration-300 animate-in slide-in-from-right-4 md:w-auto',
                    className,
                )}>
                {header && <div className="flex-shrink-0">{header}</div>}

                <div className={twMerge('flex-grow overflow-auto', contentClassName)}>{children}</div>

                {footer && <div className="flex-shrink-0">{footer}</div>}
            </div>
        </>
    );
}
